import styled from 'styled-components';

import { designSystemTokens } from '../../tokens';

/**
 * @type verticalMargins
 Margins (for **desktop** only) above and below the CallOut.
 Added because the spacing between items in the panel varies from step to step - TODO - we could possibly improve on this
 Mobile is set to 10px
 */
export type verticalMargins = 15 | 20 | 30;

type ContainerProps = {
    verticalMargins?: verticalMargins;
};

export const Container = styled.div`
    background: ${designSystemTokens.shades.primary.light[5]};
    margin: ${(props: ContainerProps) => (props.verticalMargins ? `${props.verticalMargins}px 0` : 0)};
    width: Min(100%, 340px);
    box-sizing: border-box;
    border-radius: 10px;
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        margin: 10px 0;
    }
`;

export const IconContainer = styled.div`
    margin-right: 10px;
    min-width: 30px;
    display: flex;
`;
